export const RENDER_DELAY = 500;
export const PAGE_MARGIN = 60;
export const ZOOM_MIN = 20;
export const ZOOM_MAX = 400;
export const ZOOM_STEP = 50;

/**
 * Walks through pages and finds the ideal initial zoom level (which is, fit height)
 */
export function getInitialZoom(fitPageWidth, pages, maxWidth, maxHeight) {
  var largestWidth = 0,
      largestHeight = 0;

  for(let page of pages) {
    if(largestWidth < page.width)
      largestWidth = page.width

    if(largestHeight < page.height)
      largestHeight = page.height;
  }

  return getIdealZoom(
    fitPageWidth,
    largestWidth,
    largestHeight,
    maxWidth,
    maxHeight
  );
}

/**
 * Gets ideal zoom factor
 */
export function getIdealZoom(fitPageWidth, pageWidth, pageHeight,
                                           maxWidth, maxHeight) {

  pageWidth  += PAGE_MARGIN;
  pageHeight += PAGE_MARGIN;

  var width, height;

  if(fitPageWidth) {
    width = maxWidth;
    height = (maxWidth * pageHeight) / pageWidth;
  } else {
    height = maxHeight;
    width = (maxHeight * pageWidth) / pageHeight;
  }

  return (width / pageWidth) * 100.0;
}

/**
 * Retrieves the pixel size of a page
 */
export function getPageDimensions(zoom, pageWidth, pageHeight) {
  // zoom in
  var width = pageWidth * (zoom / 100),
      height = pageHeight * (zoom / 100);

  var scale = width / pageWidth;

  return {
    width: width,
    height: height,
    scale: scale
  };
}

/**
 * Returns the index of the given array `pagePostions` that should be
 * visible to the user
 */
export function getVisiblePageIndexes(pagePositions, scrollY1, scrollHeight) {
  var scrollY2 = scrollY1 + scrollHeight,
      pageIndexes = [],
      index = 0;

  for(let page of pagePositions) {
    if( (page.y1 <= scrollY1 && page.y2 >= scrollY1 && page.y2 <= scrollY2) ||
        (page.y1 >= scrollY1 && page.y2 <= scrollY2) ||
        (page.y1 >= scrollY1 && page.y1 <= scrollY2 && page.y2 >= scrollY2) ||
        (page.y1 <= scrollY1 && page.y1 <= scrollY2 && page.y2 >= scrollY2 && page.y2 >= scrollY1) ) {
      pageIndexes.push(index);
    }

    index++;
  }

  return pageIndexes;
}

/**
 * Returns an array with page positions
 */
export function getPagePositions(pages, zoom) {
  var zoomedPageMargin = PAGE_MARGIN * zoom / 100;

  var pagePositions = { totalWidth: 0, totalHeight: 0, positions: [] },
      y1 = zoomedPageMargin,
      y2 = 0,
      index = 0;

  // walk over pages
  for(let page of pages) {
    // calc their dimensions
    let dimensions = getPageDimensions(
      zoom,
      page.width,
      page.height
    );

    // calc y1 and y2 positions
    y2 = y1 + dimensions.height + zoomedPageMargin;

    // push to our page positions stack
    pagePositions.positions.push({
      width: parseInt(dimensions.width),
      height: parseInt(dimensions.height),
      y1: parseInt(y1),
      y2: parseInt(y2)
    });

    // and.. calc the totalHeight of the document
    pagePositions.totalHeight += dimensions.height + zoomedPageMargin;

    if(pagePositions.totalWidth < dimensions.width) {
      pagePositions.totalWidth = dimensions.width;
    }

    y1 = y2;
    index++;
  }

  return pagePositions;
}

/**
 * Returns the page number that is *most* visible for the user
 */
export function getMostVisiblePageIndex(pagePositions, scrollPosition, scrollHeight, visiblePageIndexes) {
  var topY = scrollPosition,
      bottomY = scrollPosition + scrollHeight,
      maxVisibility = 0,
      visibleIndex;

  for(let index of visiblePageIndexes) {
    let pagePosition = pagePositions[index];

    let visibleTopY = pagePosition.y1,
        visibleBottomY = pagePosition.y2;

    if(visibleTopY < topY) visibleTopY = topY;
    if(visibleBottomY > bottomY) visibleBottomY = bottomY;

    let visibility = visibleBottomY - visibleTopY;

    if(visibility > maxVisibility) {
      maxVisibility = visibility;
      visibleIndex = index;
    }
  }

  return visibleIndex;
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/rendering_utils.js